import { BASE_URL } from '../configs/config';

export const sendReceipt = async (orderId: string, type: string) => {
  try {
    const res = await fetch(`${BASE_URL}sendReceipt/${orderId}?type=${type}`, {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return res;
  } catch (error) {
    return null;
  }
};
